var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{staticClass:"app-header",attrs:{"type":_vm.type,"variant":_vm.variant,"toggle-breakpoint":_vm.toggleBreakpoint,"fixed":_vm.fixed,"sticky":_vm.sticky}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }